import React from 'react';
import '../template-file-css/document-file-template.css';


export const ACS_Biopsychosocial = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='ACS_Biopsychosocial' className='file-pdf-document'>
            <div className='file-template'>

                <p>
                    <span className='eleHeader'>What is/are the presenting problem(s)?</span>
                    <span className='small'>(Why are they here? In client's own words when possible. Please include current behavior/ past 30 days of client's behavior)</span>
                    <textarea id="txtPresentingProblem" name="txtPresentingProblem" className='add-only'></textarea>
                </p>

                <p>
                    <span className='eleHeader'>History</span>
                    <span className='small'>(Early symptoms and past diagnosis; describe the onset of symptoms):</span>
                    <textarea id="txtHistory" name="txtHistory" className='add-only'></textarea>
                </p>

                <p>
                    <span className='eleHeader'>Risk of Harm</span>
                    <span className='small'>(high risks behaviors i.e. SI/HI, Impulse Control, Substance Use, Sexual behavior /Perpetrator) : </span>
                    <textarea id="txtRiskHarm" name="txtRiskHarm" className='add-only'></textarea>
                </p>

                <p>
                    <span className='eleHeader'>Trauma (i.e. sexual abuse, physical abuse, etc) : </span>
                    <textarea id="txtTrauma" name="txtTrauma" className='add-only'></textarea>
                </p>

                <p>
                    <span className='eleHeader'>Comorbidities : </span>
                    <textarea id="txtComorbidities" name="txtComorbidities" className='add-only'></textarea>
                </p>

                <p>
                    <span className='eleHeader'>Environmental Stressors</span>
                    <span className='small'>(i.e. gang activity, poverty, etc): </span>
                    <textarea id="txtEnvironmentalStressors" name="txtEnvironmentalStressors" className='add-only'></textarea>
                </p>

                <p>
                    <span className='eleHeader'>Deficits in Support System</span>
                    <span className='small'>(i.e. single parent household): </span>
                    <textarea id="txtSupportSystem" name="txtSupportSystem" className='add-only'></textarea>
                </p>

                <p>
                    <span className='eleHeader'>Transportation:</span>
                    <textarea id="txtTransportation" name="txtTransportation" className='add-only'></textarea>
                </p>

                <p>
                    <span className='eleHeader'>What service(s) is the client requesting? (What do you want to get out of the services?)</span>
                    <textarea id="txtClientRequesting" name="txtClientRequesting" className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'># of People in Family:</span>
                            <input type="text" id="txtNoPeople" name="txtNoPeople" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Adjusted Monthly Income:</span>
                            <input type="text" id="txtAdjustedMonthly" name="txtAdjustedMonthly" className='add-only' />
                        </td>
                    </tr>
                </table>

                <h2>Lifespan/Developmental History</h2>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>What is the client's prenatal history?:</span>
                            <input type="text" id="txtClientsPrenatal" name="txtClientsPrenatal" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'> Health at birth:</span>
                            <input type="text" id="txtHealth" name="txtHealth" className='add-only' />
                        </td>
                    </tr>
                </table>

                <span className='eleHeader'>Developmental milestones:</span>
                <table>
                    <tr>
                        <td>
                            <input type="checkbox" id="cbNormalLimit" name="cbNormalLimit" className='add-only' value="Within Normal Limits" /> Within Normal Limits?
                        </td>
                    </tr>
                </table>

                <p>
                    <span className='eleHeader'>Special services received during lifetime:</span>
                    <textarea id="txtSpecialServices" name="txtSpecialServices" className='add-only'></textarea>
                </p>

                <p>
                    <span className='eleHeader'>Other lifespan/developmental issues:</span>
                    <span className='small'>(Include mid-life, senior/elder, other issues)</span>
                    <textarea id="txtOtherLifespan" name="txtOtherLifespan" className='add-only'></textarea>
                </p>

                <span className='eleHeader'>Education Assessment:</span>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>School currently attending:</span>
                            <input type="text" id="txtSchoolCurrently" name="txtSchoolCurrently" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Grade:</span>
                            <input type="text" id="txtGrade" name="txtGrade" className='add-only' />
                        </td>
                    </tr>
                </table>

                <p>
                    <span className='eleHeader'>Has the client ever been suspended or expelled from school and/or bus?:</span>
                    <span className='small'>(Include both in-school suspensions and out-of-school suspensions) If so, include the number of times, dates of suspension and duration of suspension.</span>
                    <textarea id="txtExpelled" name="txtExpelled" className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span><strong>Does the client have frequent absences?: </strong></span>
                            <input type="radio" id="rbAbsences_Yes" name="rbAbsences" className='add-only' value="Yes" /> Yes &nbsp; &nbsp;
                            <input type="radio" id="rbAbsences_No" name="rbAbsences" className='add-only' value="No" /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span>(Include the number of times consumer has been absent).</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span><strong>Is the client currently failing, and has the client ever been retained?: </strong></span>
                            <input type="radio" id="rbFailing_Yes" name="rbFailing" className='add-only' value="Yes" /> Yes &nbsp; &nbsp;
                            <input type="radio" id="rbFailing_No" name="rbFailing" className='add-only' value="No" /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span><strong>Is the client in special education classes?: </strong></span>
                            <input type="radio" id="rbEducationClasses_Yes" name="rbEducationClasses" className='add-only' value="Yes" /> Yes &nbsp; &nbsp;
                            <input type="radio" id="rbEducationClasses_No" name="rbEducationClasses" className='add-only' value="No" /> No
                        </td>
                    </tr>
                </table>

                <h3>Family of Origin History</h3>
                <p>
                    <span className='eleHeader'>Family's current and past psychiatric history:</span>
                    <textarea id="txtPastPsychiatricHistory" name="txtPastPsychiatricHistory" className='add-only'></textarea>
                </p>

                <p>
                    <span className='eleHeader'>Family's and client's physical/sexual/emotional abuse history:</span>
                    <textarea id="txtEmotionalAbuseHistory" name="txtEmotionalAbuseHistory" className='add-only'></textarea>
                </p>

                <p>
                    <span className='eleHeader'>Family's substance use/abuse history:</span>
                    <textarea id="txtAbuseHistory" name="txtAbuseHistory" className='add-only'></textarea>
                </p>

                <p>
                    <span className='eleHeader'>Client's Current and Significant Past Supports:</span>
                    <span className='small'>(Social supports, family supports, significant relationships, religious and spiritual supports/affiliations.)</span>
                    <textarea id="txtSignificantPastSupports" name="txtSignificantPastSupports" className='add-only'></textarea>
                </p>

                <p>
                    <span className='eleHeader'>Other Providers/Systems involved with:</span>
                    <span className='small'>(List agencies client is involved with or receiving services from. For example: CalWORKs, ASOC, Inpatient/outpatient hospitalization, Rehab centers, etc; Include the name of the agency and primary contact person)</span>
                    <textarea id="txtOtherProviders" name="txtOtherProviders" className='add-only'></textarea>
                </p>

                <span className='eleHeader'>Client's Legal History:</span>
                <table>
                    <tr>
                        <td className='w-250'><input type="checkbox" id="cbCLH_1" name="cbCLH_1" className='add-only' value="Informal Probation" /> Informal Probation</td>
                        <td className='w-250'><input type="checkbox" id="cbCLH_2" name="cbCLH_2" className='add-only' value="Formal Probation" /> Formal Probation</td>
                        <td className='w-250'><input type="checkbox" id="cbCLH_3" name="cbCLH_3" className='add-only' value="Parole" /> Parole</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type="checkbox" id="cbCLH_4" name="cbCLH_4" className='add-only' value="Child Welfare Services" /> Child Welfare Services</td>
                        <td className='w-250'><input type="checkbox" id="cbCLH_5" name="cbCLH_5" className='add-only' value="Conservatorship" /> Conservatorship</td>
                        <td className='w-250'><input type="checkbox" id="cbCLH_6" name="cbCLH_6" className='add-only' value="DUI" /> D. U. I.</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type="checkbox" id="cbCLH_7" name="cbCLH_7" className='add-only' value="Restraining Order" /> Restraining Order </td>
                        <td className='w-250'><input type="checkbox" id="cbCLH_8" name="cbCLH_8" className='add-only' value="None reported" /> None reported</td>
                    </tr>
                </table>

                <p>
                    <span className='eleHeader'>(Describe and, if currently involved, give name of probation officer, parole office, or case manager and estimated start and end dates.)</span>
                    <textarea id="txtProbationOfficer" name="txtProbationOfficer" className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span><strong>Client's Substance Use:</strong></span>
                            <input type="radio" id="rbSubstanceUse_Yes" name="rbSubstanceUse" className='add-only' value="Yes" /> Yes &nbsp;
                            <input type="radio" id="rbSubstanceUse_No" name="rbSubstanceUse" className='add-only' value="No" /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span><strong>(Alcohol and other drugs, check all that apply.)</strong></span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type="checkbox" id="cbSubstanceUse_1" name="cbSubstanceUse_1" className='add-only' value="Caffeine" /> Caffeine</td>
                        <td className='w-250'><input type="checkbox" id="cbSubstanceUse_2" name="cbSubstanceUse_2" className='add-only' value="Tobacco" /> Tobacco</td>
                        <td className='w-250'><input type="checkbox" id="cbSubstanceUse_3" name="cbSubstanceUse_3" className='add-only' value="Over-the-counter Medication" /> Over-the-counter Medication</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type="checkbox" id="cbSubstanceUse_4" name="cbSubstanceUse_4" className='add-only' value="Prescription Medication" /> Prescription Medication</td>
                        <td className='w-250'><input type="checkbox" id="cbSubstanceUse_5" name="cbSubstanceUse_5" className='add-only' value="Alcohol" /> Alcohol</td>
                        <td className='w-250'><input type="checkbox" id="cbSubstanceUse_6" name="cbSubstanceUse_6" className='add-only' value="Inhalants" /> Inhalants </td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type="checkbox" id="cbSubstanceUse_7" name="cbSubstanceUse_7" className='add-only' value="Hallucinogens" /> Hallucinogens </td>
                        <td className='w-250'><input type="checkbox" id="cbSubstanceUse_8" name="cbSubstanceUse_8" className='add-only' value="Marijuana" /> Marijuana</td>
                        <td className='w-250'><input type="checkbox" id="cbSubstanceUse_9" name="cbSubstanceUse_9" className='add-only' value="Stimulants" /> Stimulants</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type="checkbox" id="cbSubstanceUse_10" name="cbSubstanceUse_10" className='add-only' value="Sedatives" /> Sedatives </td>
                        <td className='w-250'><input type="checkbox" id="cbSubstanceUse_11" name="cbSubstanceUse_11" className='add-only' value="Tranqulizers" /> Tranqulizers</td>
                        <td className='w-250'><input type="checkbox" id="cbSubstanceUse_12" name="cbSubstanceUse_12" className='add-only' value="Cocaine" /> Cocaine</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type="checkbox" id="cbSubstanceUse_13" name="cbSubstanceUse_13" className='add-only' value="Barbituates" /> Barbituates </td>
                        <td className='w-250'><input type="checkbox" id="cbSubstanceUse_14" name="cbSubstanceUse_14" className='add-only' value="Methamphetamines" /> Methamphetamines</td>
                        <td className='w-250'><input type="checkbox" id="cbSubstanceUse_15" name="cbSubstanceUse_15" className='add-only' value="Opiates" /> Opiates</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type="checkbox" id="cbSubstanceUse_16" name="cbSubstanceUse_16" className='add-only' value="Methadone" /> Methadone </td>
                        <td className='w-250'><input type="checkbox" id="cbSubstanceUse_17" name="cbSubstanceUse_17" className='add-only' value="Other" /> Other</td>
                    </tr>
                </table>

                <p>
                    <span className='eleHeader'>Client's history of withdrawal, DTs, blackouts (loss of time), seizures, etc. If applicable.</span>
                    <textarea id="txtClientHistoryBlackouts" name="txtClientHistoryBlackouts" className='add-only'></textarea>
                </p>

                <p>
                    <span className='eleHeader'>Ask and record the response to, "What happens when you stop using?":</span>
                    <textarea id="txtResponse" name="txtResponse" className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>What is the longest period of sobriety?:</span>
                            <input type="text" id="txtLongestPeriod" name="txtLongestPeriod" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>When?:</span>
                            <input type="text" id="txtWhen" name="txtWhen" className='add-only' />
                        </td>
                    </tr>
                </table>

                <h2>Mental Health Services History</h2>
                <span className='eleHeader'>Mental Status Exam</span>
                <table>
                    <tr>
                        <td className='w-750'><span><strong>Appearance:</strong></span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type="checkbox" id="cbAppearance_1" name="cbAppearance_1" className='add-only' value="Unremarkable" /> Unremarkable</td>
                        <td className='w-250'><input type="checkbox" id="cbAppearance_2" name="cbAppearance_2" className='add-only' value="Unkempt" /> Unkempt</td>
                        <td className='w-250'><input type="checkbox" id="cbAppearance_3" name="cbAppearance_3" className='add-only' value="Atypical Clothing" /> Atypical Clothing</td>
                    </tr>
                    <tr>
                        <td className='w-750'><span><strong>Orientation:</strong></span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type="checkbox" id="cbOrientation_1" name="cbOrientation_1" className='add-only' value="Person" /> Person</td>
                        <td className='w-250'><input type="checkbox" id="cbOrientation_2" name="cbOrientation_2" className='add-only' value="Place" /> Place</td>
                        <td className='w-250'><input type="checkbox" id="cbOrientation_3" name="cbOrientation_3" className='add-only' value="Date" /> Date</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type="checkbox" id="cbOrientation_4" name="cbOrientation_4" className='add-only' value="Situation" /> Situation</td>
                    </tr>
                    <tr>
                        <td className='w-750'><span><strong>Insight:</strong></span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type="checkbox" id="cbInsight_1" name="cbInsight_1" className='add-only' value="Poor" /> Poor</td>
                        <td className='w-250'><input type="checkbox" id="cbInsight_2" name="cbInsight_2" className='add-only' value="Average" /> Average</td>
                        <td className='w-250'><input type="checkbox" id="cbInsight_3" name="cbInsight_3" className='add-only' value="Good" /> Good</td>
                    </tr>
                    <tr>
                        <td className='w-750'><span><strong>Judgment:</strong></span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type="checkbox" id="cbJudgment_1" name="cbJudgment_1" className='add-only' value="Poor" /> Poor</td>
                        <td className='w-250'><input type="checkbox" id="cbJudgment_2" name="cbJudgment_2" className='add-only' value="Average" /> Average</td>
                        <td className='w-250'><input type="checkbox" id="cbJudgment_3" name="cbJudgment_3" className='add-only' value="Good" /> Good</td>
                    </tr>
                </table>

                <p>
                    <span className='eleHeader'>Comments:</span>
                    <textarea id="txtComments" name="txtComments" className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'><span><strong>Motor Activity:</strong></span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type="checkbox" id="cbMotorActivity_1" name="cbMotorActivity_1" className='add-only' value="Unremarkable" /> Unremarkable</td>
                        <td className='w-250'><input type="checkbox" id="cbMotorActivity_2" name="cbMotorActivity_2" className='add-only' value="Restless" /> Restless</td>
                        <td className='w-250'><input type="checkbox" id="cbMotorActivity_3" name="cbMotorActivity_3" className='add-only' value="Withdrawn" /> Withdrawn</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type="checkbox" id="cbMotorActivity_4" name="cbMotorActivity_4" className='add-only' value="Slurred Speech" /> Slurred Speech</td>
                    </tr>
                    <tr>
                        <td className='w-750'><span><strong>Biological Functions:</strong></span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type="checkbox" id="cbBiologicalFunctions_1" name="cbBiologicalFunctions_1" className='add-only' value="All within normal limits" /> All within normal limits</td>
                    </tr>
                </table>

                <p>
                    <span className='eleHeader'>Sleep Pattern:</span>
                    <textarea id="txtSleepPattern" name="txtSleepPattern" className='add-only'></textarea>
                </p>

                <p>
                    <span className='eleHeader'>Appetite:</span>
                    <textarea id="txtAppetite" name="txtAppetite" className='add-only'></textarea>
                </p>

                <p>
                    <span className='eleHeader'>Comments:</span>
                    <textarea id="txtComments_1" name="txtComments_1" className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'><span><strong>Affect:</strong></span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type="checkbox" id="cbAffect_1" name="cbAffect_1" className='add-only' value="Unremarkable" /> Unremarkable</td>
                        <td className='w-250'><input type="checkbox" id="cbAffect_2" name="cbAffect_2" className='add-only' value="Angry" /> Angry</td>
                        <td className='w-250'><input type="checkbox" id="cbAffect_3" name="cbAffect_3" className='add-only' value="Irritable" /> Irritable</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type="checkbox" id="cbAffect_4" name="cbAffect_4" className='add-only' value="Self Critical" /> Self Critical</td>
                        <td className='w-250'><input type="checkbox" id="cbAffect_5" name="cbAffect_5" className='add-only' value="Euphoric" /> Euphoric</td>
                        <td className='w-250'><input type="checkbox" id="cbAffect_6" name="cbAffect_6" className='add-only' value="Depressed" /> Depressed</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type="checkbox" id="cbAffect_7" name="cbAffect_7" className='add-only' value="Flat" /> Flat</td>
                        <td className='w-250'><input type="checkbox" id="cbAffect_8" name="cbAffect_8" className='add-only' value="Silly" /> Silly</td>
                        <td className='w-250'><input type="checkbox" id="cbAffect_9" name="cbAffect_9" className='add-only' value="Hopelessness" /> Hopelessness</td>
                    </tr>
                    <tr>
                        <td className='w-750'><span><strong>Depressive-Like Behavior:</strong></span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type="checkbox" id="cbDepressiveBehavior_1" name="cbDepressiveBehavior_1" className='add-only' value="None" /> None</td>
                        <td className='w-250'><input type="checkbox" id="cbDepressiveBehavior_2" name="cbDepressiveBehavior_2" className='add-only' value="Irritability" /> Irritability</td>
                        <td className='w-250'><input type="checkbox" id="cbDepressiveBehavior_3" name="cbDepressiveBehavior_3" className='add-only' value="Withdrawn" /> Withdrawn</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type="checkbox" id="cbDepressiveBehavior_4" name="cbDepressiveBehavior_4" className='add-only' value="Hypoactive" /> Hypoactive</td>
                        <td className='w-250'><input type="checkbox" id="cbDepressiveBehavior_5" name="cbDepressiveBehavior_5" className='add-only' value="Poor Concentration" /> Poor Concentration</td>
                        <td className='w-250'><input type="checkbox" id="cbDepressiveBehavior_6" name="cbDepressiveBehavior_6" className='add-only' value="Self-Blame/Self-Criticism" /> Self-Blame/Self-Criticism</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type="checkbox" id="cbDepressiveBehavior_7" name="cbDepressiveBehavior_7" className='add-only' value="Fatigue" /> Fatigue</td>
                        <td className='w-250'><input type="checkbox" id="cbDepressiveBehavior_8" name="cbDepressiveBehavior_8" className='add-only' value="Sadness" /> Sadness</td>
                        <td className='w-250'><input type="checkbox" id="cbDepressiveBehavior_9" name="cbDepressiveBehavior_9" className='add-only' value="Loss of Interest" /> Loss of Interest</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type="checkbox" id="cbDepressiveBehavior_10" name="cbDepressiveBehavior_10" className='add-only' value="Feelings of Worthlessness" /> Feelings of Worthlessness</td>
                        <td className='w-250'><input type="checkbox" id="cbDepressiveBehavior_11" name="cbDepressiveBehavior_11" className='add-only' value="Change in Sexaul Interest" /> Change in Sexaul Interest</td>
                        <td className='w-250'><input type="checkbox" id="cbDepressiveBehavior_12" name="cbDepressiveBehavior_12" className='add-only' value="Crying" /> Crying</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type="checkbox" id="cbDepressiveBehavior_13" name="cbDepressiveBehavior_13" className='add-only' value="Guilt Feelings" /> Guilt Feelings</td>
                        <td className='w-500'><input type="checkbox" id="cbDepressiveBehavior_14" name="cbDepressiveBehavior_14" className='add-only' value="Loss of Ability to Enjoy" /> Loss of Ability to Enjoy (Anhedonia)</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type="checkbox" id="cbDepressiveBehavior_15" name="cbDepressiveBehavior_15" className='add-only' value="Feelings of Helpless/Hopeless" /> Feelings of Helpless/Hopeless</td>
                    </tr>
                </table>

                <p>
                    <span className='eleHeader'>Comments:</span>
                    <textarea id="txtComments_2" name="txtComments_2" className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span><strong>Thinking:</strong></span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type="checkbox" id="cbThinking_1" name="cbThinking_1" className='add-only' value="Unremarkable" /> Unremarkable</td>
                        <td className='w-250'><input type="checkbox" id="cbThinking_2" name="cbThinking_2" className='add-only' value="Disorganized" /> Disorganized</td>
                        <td className='w-250'><input type="checkbox" id="cbThinking_3" name="cbThinking_3" className='add-only' value="Flight of Ideas" /> Flight of Ideas</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type="checkbox" id="cbThinking_4" name="cbThinking_4" className='add-only' value="Distracted" /> Distracted</td>
                        <td className='w-250'><input type="checkbox" id="cbThinking_5" name="cbThinking_5" className='add-only' value="Suspicious" /> Suspicious</td>
                        <td className='w-250'><input type="checkbox" id="cbThinking_6" name="cbThinking_6" className='add-only' value="Confused" /> Confused</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type="checkbox" id="cbThinking_7" name="cbThinking_7" className='add-only' value="Delusions" /> Delusions</td>
                        <td className='w-250'><input type="checkbox" id="cbThinking_8" name="cbThinking_8" className='add-only' value="Obsessions" /> Obsessions</td>
                        <td className='w-250'><input type="checkbox" id="cbThinking_9" name="cbThinking_9" className='add-only' value="Grandiosity" /> Grandiosity</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type="checkbox" id="cbThinking_10" name="cbThinking_10" className='add-only' value="Hypochondriasis" /> Hypochondriasis</td>
                    </tr>
                </table>

                <p>
                    <span className='eleHeader'>Comments:</span>
                    <textarea id="txtComments_3" name="txtComments_3" className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span><strong>Attitude:</strong></span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type="checkbox" id="cbAttitude_1" name="cbAttitude_1" className='add-only' value="Unremarkable" /> Unremarkable</td>
                        <td className='w-250'><input type="checkbox" id="cbAttitude_2" name="cbAttitude_2" className='add-only' value="Controlling" /> Controlling</td>
                        <td className='w-250'><input type="checkbox" id="cbAttitude_3" name="cbAttitude_3" className='add-only' value="Passive-Aggressive" /> Passive-Aggressive</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type="checkbox" id="cbAttitude_4" name="cbAttitude_4" className='add-only' value="Egocentric" /> Egocentric</td>
                        <td className='w-250'><input type="checkbox" id="cbAttitude_5" name="cbAttitude_5" className='add-only' value="Hostile" /> Hostile</td>
                        <td className='w-250'><input type="checkbox" id="cbAttitude_6" name="cbAttitude_6" className='add-only' value="Seductive" /> Seductive</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type="checkbox" id="cbAttitude_7" name="cbAttitude_7" className='add-only' value="Sarcastic" /> Sarcastic</td>
                        <td className='w-250'><input type="checkbox" id="cbAttitude_8" name="cbAttitude_8" className='add-only' value="Negativistic" /> Negativistic</td>
                        <td className='w-250'><input type="checkbox" id="cbAttitude_9" name="cbAttitude_9" className='add-only' value="Manipulative" /> Manipulative</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type="checkbox" id="cbAttitude_10" name="cbAttitude_10" className='add-only' value="Resistant" /> Resistant</td>
                        <td className='w-250'><input type="checkbox" id="cbAttitude_11" name="cbAttitude_11" className='add-only' value="Passive" /> Passive</td>
                    </tr>
                </table>

                <p>
                    <span className='eleHeader'>Comments:</span>
                    <textarea id="txtComments_4" name="txtComments_4" className='add-only'></textarea>
                </p>

                <p>
                    <span className='eleHeader'>Medical History/Information:</span>
                    <textarea id="txtMedicalHistory" name="txtMedicalHistory" className='add-only'></textarea>
                </p>

                <p>
                    <span className='eleHeader'>Medical Conditions:</span>
                    <span className='small'>(List significant past and present medical conditions, including allergies, recent lab results, etc .)</span>
                    <textarea id="txtMedicalConditions" name="txtMedicalConditions" className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Primary Care Physician's Contact Information:</span>
                            <input type="text" id="txtContactInformation" name="txtContactInformation" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Date of last physical examinations:</span>
                            <input type="date" id="txtPhysicalExaminations" name="txtPhysicalExaminations" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Current with immunizations?:</span>
                            <input type="radio" id="rbImmunizations_Yes" name="rbImmunizations" className='add-only' value="Yes" /> Yes &nbsp;
                            <input type="radio" id="rbImmunizations_No" name="rbImmunizations" className='add-only' value="No" /> No
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Consumer's Height:</span>
                            <input type="text" id="txtConsumerHeight" name="txtConsumerHeight" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Consumer's Weight:</span>
                            <input type="text" id="txtConsumerWeight" name="txtConsumerWeight" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span><strong>Consumer Satisfied with Current Weight?:</strong></span>
                            <input type="radio" id="rbCurrentWeight_NA" name="rbCurrentWeight" className='add-only' value="NA" /> N/A &nbsp;
                            <input type="radio" id="rbCurrentWeight_Yes" name="rbCurrentWeight" className='add-only' value="Yes" /> Yes &nbsp;
                            <input type="radio" id="rbCurrentWeight_No" name="rbCurrentWeight" className='add-only' value="No" /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span><strong>Ever Diagnosed with an Eating Disorder?:</strong></span>
                            <input type="radio" id="rbEatingDisorder_NA" name="rbEatingDisorder" className='add-only' value="NA" /> N/A &nbsp;
                            <input type="radio" id="rbEatingDisorder_Yes" name="rbEatingDisorder" className='add-only' value="Yes" /> Yes &nbsp;
                            <input type="radio" id="rbEatingDisorder_No" name="rbEatingDisorder" className='add-only' value="No" /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span><strong>Consumer Need a Referral for a Nutritional Assessment?:</strong></span>
                            <input type="radio" id="rbNutritionalAssessment_NA" name="rbNutritionalAssessment" className='add-only' value="NA" /> N/A &nbsp;
                            <input type="radio" id="rbNutritionalAssessment_Yes" name="rbNutritionalAssessment" className='add-only' value="Yes" /> Yes &nbsp;
                            <input type="radio" id="rbNutritionalAssessment_No" name="rbNutritionalAssessment" className='add-only' value="No" /> No
                        </td>
                    </tr>
                </table>

                <span className='eleHeader'>Medication History</span>
                <table>
                    <tr>
                        <td className='w-200'><span><strong>Medication Name</strong></span></td>
                        <td className='w-100'><span><strong>Dosage/ Frequency</strong></span></td>
                        <td className='w-150'><span><strong>Effective</strong></span></td>
                        <td className='w-100'><span><strong>Compliance</strong></span></td>
                        <td className='w-200'><span><strong>Prescribed By</strong></span></td>
                    </tr>
                    <tr>
                        <td className='w-200'><input type="text" id="txtMedicationName_1" name="txtMedicationName_1" className='add-only'  /></td>
                        <td className='w-100'><input type="text" id="txtDosage_1" name="txtDosage_1" className='add-only'  /></td>
                        <td className='w-150'><input type="text" id="txtEffective_1" name="txtEffective_1" className='add-only'  /></td>
                        <td className='w-100'><input type="text" id="txtCompliance_1" name="txtCompliance_1" className='add-only'  /></td>
                        <td className='w-200'><input type="text" id="txtPrescribed_1" name="txtPrescribed_1" className='add-only'  /></td>
                    </tr>
                    <tr>
                        <td className='w-200'><input type="text" id="txtMedicationName_2" name="txtMedicationName_2" className='add-only'  /></td>
                        <td className='w-100'><input type="text" id="txtDosage_2" name="txtDosage_2" className='add-only'  /></td>
                        <td className='w-150'><input type="text" id="txtEffective_2" name="txtEffective_2" className='add-only'  /></td>
                        <td className='w-100'><input type="text" id="txtCompliance_2" name="txtCompliance_2" className='add-only'  /></td>
                        <td className='w-200'><input type="text" id="txtPrescribed_2" name="txtPrescribed_2" className='add-only'  /></td>
                    </tr>
                    <tr>
                        <td className='w-200'><input type="text" id="txtMedicationName_3" name="txtMedicationName_3" className='add-only'  /></td>
                        <td className='w-100'><input type="text" id="txtDosage_3" name="txtDosage_3" className='add-only'  /></td>
                        <td className='w-150'><input type="text" id="txtEffective_3" name="txtEffective_3" className='add-only'  /></td>
                        <td className='w-100'><input type="text" id="txtCompliance_3" name="txtCompliance_3" className='add-only'  /></td>
                        <td className='w-200'><input type="text" id="txtPrescribed_3" name="txtPrescribed_3" className='add-only'  /></td>
                    </tr>
                </table>

                <p>
                    <span className='eleHeader'>Daily Living Skills (Personal Care, Laundry, Cleaning):</span>
                    <textarea id="txtDailyLivingSkills" name="txtDailyLivingSkills" className='add-only'></textarea>
                </p>

                <p>
                    <span className='eleHeader'>(List All Tasks that consumer is able to complete/Strengths)</span>
                    <textarea id="txtStrength" name="txtStrength" className='add-only'></textarea>
                </p>
                <p>
                            <span><strong>Does client require assistive technology?</strong></span>
                            &nbsp;
                            <input type="radio" id="rbAssistiveTechnology_Yes" name="rbAssistiveTechnology" className='add-only' value="Yes" /> Yes &nbsp;
                            <input type="radio" id="rbAssistiveTechnology_No" name="rbAssistiveTechnology" className='add-only' value="No" /> No
                        
                </p> 

                <p>
                    <span className='eleHeader'>(If yes, specify what is needed.)</span>
                    <textarea id="txtSpecify" name="txtSpecify" className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td>
                            <span><strong>Does client display impairment in:</strong></span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type="checkbox" id="cbSpeech" name="cbSpeech" className='add-only' value="Speech" /> Speech</td>
                        <td className='w-250'><input type="checkbox" id="cbLanguage" name="cbLanguage" className='add-only' value="Language" /> Language</td>
                        <td className='w-250'><input type="checkbox" id="cbVision" name="cbVision" className='add-only' value="Vision" /> Vision</td>
                    </tr>
                </table>

                <p>
                    <span className='eleHeader'>Relationship Analysis:</span>
                    <span className='small'>(Consumer's relationship status, gender identity, etc.)</span>
                    <textarea id="txtRelationship" name="txtRelationship" className='add-only'></textarea>
                </p>
                <p>
                    <b>Rate severity and duration for each:</b>
                </p> 

                <table>
                    <tr>  
                        <td className='w-250'><span className='eleHeader'>Current Symptoms/Problems</span></td> 
                        <td className='w-250'><span className='eleHeader'>Rate severity</span></td> 
                        <td className='w-250'><span className='eleHeader'>Rate duration</span></td>  
                    </tr>
                    <tr> 
                        <td className='w-250'><b>Anxiety</b></td> 
                        <td className='w-250'>
                            <select id="ddlAnxiety_1" name="ddlAnxiety_1" className='add-only'>
                                <option value=""></option>
                                <option value="None">None</option>
                                <option value="Mild">Mild</option>
                                <option value="Moderate">Moderate</option>
                                <option value="Severe">Severe</option>
                            </select></td> 
                        <td className='w-250'>
                            <select id="ddlAnxiety_2" name="ddlAnxiety_2" className='add-only'>
                                <option value=""></option>
                                <option value="0">None</option>
                                <option value="1">&#60; Month</option>
                                <option value="2">1 - 6 Months</option>
                                <option value="3">7 - 11 Months</option>
                                <option value="4">&#62; 1 Year</option>
                            </select></td> 
                    </tr>
                    <tr> 
                        <td className='w-250'><b>Panic Attacks</b></td> 
                        <td className='w-250'>
                            <select id="ddlPanicAttacks_1" name="ddlPanicAttacks_1" className='add-only'>
                                <option value=""></option>
                                <option value="None">None</option>
                                <option value="Mild">Mild</option>
                                <option value="Moderate">Moderate</option>
                                <option value="Severe">Severe</option>
                            </select></td> 
                        <td className='w-250'>
                            <select id="ddlPanicAttacks_2" name="ddlPanicAttacks_2" className='add-only'>
                                <option value=""></option>
                                <option value="0">None</option>
                                <option value="1">&#60; Month</option>
                                <option value="2">1 - 6 Months</option>
                                <option value="3">7 - 11 Months</option>
                                <option value="4">&#62; 1 Year</option>
                            </select></td> 
                    </tr>
                    <tr> 
                        <td className='w-250'><b>Phobia Compulsive</b></td> 
                        <td className='w-250'>
                            <select id="ddlPhobia_1" name="ddlPhobia_1" className='add-only'>
                                <option value=""></option>
                                <option value="None">None</option>
                                <option value="Mild">Mild</option>
                                <option value="Moderate">Moderate</option>
                                <option value="Severe">Severe</option>
                            </select></td> 
                        <td className='w-250'>
                            <select id="ddlPhobia_2" name="ddlPhobia_2" className='add-only'>
                                <option value=""></option>
                                <option value="0">None</option>
                                <option value="1">&#60; Month</option>
                                <option value="2">1 - 6 Months</option>
                                <option value="3">7 - 11 Months</option>
                                <option value="4">&#62; 1 Year</option>
                            </select></td> 
                    </tr> 
                    <tr> 
                        <td className='w-250'><b>Obessive</b></td> 
                        <td className='w-250'>
                            <select id="ddlObessive_1" name="ddlObessive_1" className='add-only'>
                                <option value=""></option>
                                <option value="None">None</option>
                                <option value="Mild">Mild</option>
                                <option value="Moderate">Moderate</option>
                                <option value="Severe">Severe</option>
                            </select></td> 
                        <td className='w-250'>
                            <select id="ddlObessive_2" name="ddlObessive_2" className='add-only'>
                                <option value=""></option>
                                <option value="0">None</option>
                                <option value="1">&#60; Month</option>
                                <option value="2">1 - 6 Months</option>
                                <option value="3">7 - 11 Months</option>
                                <option value="4">&#62; 1 Year</option>
                            </select></td> 
                    </tr> 
                    <tr> 
                        <td className='w-250'><b>Somatization</b></td> 
                        <td className='w-250'>
                            <select id="ddlSomatization_1" name="ddlSomatization_1" className='add-only'>
                                <option value=""></option>
                                <option value="None">None</option>
                                <option value="Mild">Mild</option>
                                <option value="Moderate">Moderate</option>
                                <option value="Severe">Severe</option>
                            </select></td> 
                        <td className='w-250'>
                            <select id="ddlSomatization_2" name="ddlSomatization_2" className='add-only'>
                                <option value=""></option>
                                <option value="0">None</option>
                                <option value="1">&#60; Month</option>
                                <option value="2">1 - 6 Months</option>
                                <option value="3">7 - 11 Months</option>
                                <option value="4">&#62; 1 Year</option>
                            </select></td> 
                    </tr> 
                    <tr> 
                        <td className='w-250'><b>Depression</b></td> 
                        <td className='w-250'>
                            <select id="ddlDepression_1" name="ddlDepression_1" className='add-only'>
                                <option value=""></option>
                                <option value="None">None</option>
                                <option value="Mild">Mild</option>
                                <option value="Moderate">Moderate</option>
                                <option value="Severe">Severe</option>
                            </select></td> 
                        <td className='w-250'>
                            <select id="ddlDepression_2" name="ddlDepression_2" className='add-only'>
                                <option value=""></option>
                                <option value="0">None</option>
                                <option value="1">&#60; Month</option>
                                <option value="2">1 - 6 Months</option>
                                <option value="3">7 - 11 Months</option>
                                <option value="4">&#62; 1 Year</option>
                            </select></td> 
                    </tr> 
                    <tr> 
                        <td className='w-250'><b>Impaired Memory</b></td> 
                        <td className='w-250'>
                            <select id="ddlImpairedMemory_1" name="ddlImpairedMemory_1" className='add-only'>
                                <option value=""></option>
                                <option value="None">None</option>
                                <option value="Mild">Mild</option>
                                <option value="Moderate">Moderate</option>
                                <option value="Severe">Severe</option>
                            </select></td> 
                        <td className='w-250'>
                            <select id="ddlImpairedMemory_2" name="ddlImpairedMemory_2" className='add-only'>
                                <option value=""></option>
                                <option value="0">None</option>
                                <option value="1">&#60; Month</option>
                                <option value="2">1 - 6 Months</option>
                                <option value="3">7 - 11 Months</option>
                                <option value="4">&#62; 1 Year</option>
                            </select></td> 
                    </tr> 
                    <tr> 
                        <td className='w-250'><b>Poor Self Care Skills</b></td> 
                        <td className='w-250'>
                            <select id="ddlCareSkills_1" name="ddlCareSkills_1" className='add-only'>
                                <option value=""></option>
                                <option value="None">None</option>
                                <option value="Mild">Mild</option>
                                <option value="Moderate">Moderate</option>
                                <option value="Severe">Severe</option>
                            </select></td> 
                        <td className='w-250'>
                            <select id="ddlCareSkills_2" name="ddlCareSkills_2" className='add-only'>
                                <option value=""></option>
                                <option value="0">None</option>
                                <option value="1">&#60; Month</option>
                                <option value="2">1 - 6 Months</option>
                                <option value="3">7 - 11 Months</option>
                                <option value="4">&#62; 1 Year</option>
                            </select></td> 
                    </tr> 
                    <tr> 
                        <td className='w-250'><b>Loss of Interest</b></td> 
                        <td className='w-250'>
                            <select id="ddlInterest_1" name="ddlInterest_1" className='add-only'>
                                <option value=""></option>
                                <option value="None">None</option>
                                <option value="Mild">Mild</option>
                                <option value="Moderate">Moderate</option>
                                <option value="Severe">Severe</option>
                            </select></td> 
                        <td className='w-250'>
                            <select id="ddlInterest_2" name="ddlInterest_2" className='add-only'>
                                <option value=""></option>
                                <option value="0">None</option>
                                <option value="1">&#60; Month</option>
                                <option value="2">1 - 6 Months</option>
                                <option value="3">7 - 11 Months</option>
                                <option value="4">&#62; 1 Year</option>
                            </select></td> 
                    </tr> 
                    <tr> 
                        <td className='w-250'><b>Sexual Dysfunction</b></td> 
                        <td className='w-250'>
                            <select id="ddlDysfunction_1" name="ddlDysfunction_1" className='add-only'>
                                <option value=""></option>
                                <option value="None">None</option>
                                <option value="Mild">Mild</option>
                                <option value="Moderate">Moderate</option>
                                <option value="Severe">Severe</option>
                            </select></td> 
                        <td className='w-250'>
                            <select id="ddlDysfunction_2" name="ddlDysfunction_2" className='add-only'>
                                <option value=""></option>
                                <option value="0">None</option>
                                <option value="1">&#60; Month</option>
                                <option value="2">1 - 6 Months</option>
                                <option value="3">7 - 11 Months</option>
                                <option value="4">&#62; 1 Year</option>
                            </select></td> 
                    </tr> 
                    <tr> 
                        <td className='w-250'><b>Weight Change</b></td> 
                        <td className='w-250'>
                            <select id="ddlWeightChange_1" name="ddlWeightChange_1" className='add-only'>
                                <option value=""></option>
                                <option value="None">None</option>
                                <option value="Mild">Mild</option>
                                <option value="Moderate">Moderate</option>
                                <option value="Severe">Severe</option>
                            </select></td> 
                        <td className='w-250'>
                            <select id="ddlWeightChange_2" name="ddlWeightChange_2" className='add-only'>
                                <option value=""></option>
                                <option value="0">None</option>
                                <option value="1">&#60; Month</option>
                                <option value="2">1 - 6 Months</option>
                                <option value="3">7 - 11 Months</option>
                                <option value="4">&#62; 1 Year</option>
                            </select></td> 
                    </tr> 
                    <tr> 
                        <td className='w-250'><b>Bizarre Ideation</b></td> 
                        <td className='w-250'>
                            <select id="ddlBizarreIdeation_1" name="ddlBizarreIdeation_1" className='add-only'>
                                <option value=""></option>
                                <option value="None">None</option>
                                <option value="Mild">Mild</option>
                                <option value="Moderate">Moderate</option>
                                <option value="Severe">Severe</option>
                            </select></td> 
                        <td className='w-250'>
                            <select id="ddlBizarreIdeation_2" name="ddlBizarreIdeation_2" className='add-only'>
                                <option value=""></option>
                                <option value="0">None</option>
                                <option value="1">&#60; Month</option>
                                <option value="2">1 - 6 Months</option>
                                <option value="3">7 - 11 Months</option>
                                <option value="4">&#62; 1 Year</option>
                            </select></td> 
                    </tr> 
                    <tr> 
                        <td className='w-250'><b>Bizarre Behavior</b></td> 
                        <td className='w-250'>
                            <select id="ddlBizarreBehavior_1" name="ddlBizarreBehavior_1" className='add-only'>
                                <option value=""></option>
                                <option value="None">None</option>
                                <option value="Mild">Mild</option>
                                <option value="Moderate">Moderate</option>
                                <option value="Severe">Severe</option>
                            </select></td> 
                        <td className='w-250'>
                            <select id="ddlBizarreBehavior_2" name="ddlBizarreBehavior_2" className='add-only'>
                                <option value=""></option>
                                <option value="0">None</option>
                                <option value="1">&#60; Month</option>
                                <option value="2">1 - 6 Months</option>
                                <option value="3">7 - 11 Months</option>
                                <option value="4">&#62; 1 Year</option>
                            </select></td> 
                    </tr> 
                    <tr> 
                        <td className='w-250'><b>Paranoid Ideation</b></td> 
                        <td className='w-250'>
                            <select id="ddlParanoidIdeation_1" name="ddlParanoidIdeation_1" className='add-only'>
                                <option value=""></option>
                                <option value="None">None</option>
                                <option value="Mild">Mild</option>
                                <option value="Moderate">Moderate</option>
                                <option value="Severe">Severe</option>
                            </select></td> 
                        <td className='w-250'>
                            <select id="ddlParanoidIdeation_2" name="ddlParanoidIdeation_2" className='add-only'>
                                <option value=""></option>
                                <option value="0">None</option>
                                <option value="1">&#60; Month</option>
                                <option value="2">1 - 6 Months</option>
                                <option value="3">7 - 11 Months</option>
                                <option value="4">&#62; 1 Year</option>
                            </select></td> 
                    </tr> 
                    <tr> 
                        <td className='w-250'><b>Poor Judgment</b></td> 
                        <td className='w-250'>
                            <select id="ddlPoorJudgment_1" name="ddlPoorJudgment_1" className='add-only'>
                                <option value=""></option>
                                <option value="None">None</option>
                                <option value="Mild">Mild</option>
                                <option value="Moderate">Moderate</option>
                                <option value="Severe">Severe</option>
                            </select></td> 
                        <td className='w-250'>
                            <select id="ddlPoorJudgment_2" name="ddlPoorJudgment_2" className='add-only'>
                                <option value=""></option>
                                <option value="0">None</option>
                                <option value="1">&#60; Month</option>
                                <option value="2">1 - 6 Months</option>
                                <option value="3">7 - 11 Months</option>
                                <option value="4">&#62; 1 Year</option>
                            </select></td> 
                    </tr> 
                    <tr> 
                        <td className='w-250'><b>Poor Interpersonal Skills</b></td> 
                        <td className='w-250'>
                            <select id="ddlInterpersonalSkills_1" name="ddlInterpersonalSkills_1" className='add-only'>
                                <option value=""></option>
                                <option value="None">None</option>
                                <option value="Mild">Mild</option>
                                <option value="Moderate">Moderate</option>
                                <option value="Severe">Severe</option>
                            </select></td> 
                        <td className='w-250'>
                            <select id="ddlInterpersonalSkills_2" name="ddlInterpersonalSkills_2" className='add-only'>
                                <option value=""></option>
                                <option value="0">None</option>
                                <option value="1">&#60; Month</option>
                                <option value="2">1 - 6 Months</option>
                                <option value="3">7 - 11 Months</option>
                                <option value="4">&#62; 1 Year</option>
                            </select></td> 
                    </tr>
                    <tr> 
                        <td className='w-250'><b>Conduct Problems</b></td> 
                        <td className='w-250'>
                            <select id="ddlConductProblems_1" name="ddlConductProblems_1" className='add-only'>
                                <option value=""></option>
                                <option value="None">None</option>
                                <option value="Mild">Mild</option>
                                <option value="Moderate">Moderate</option>
                                <option value="Severe">Severe</option>
                            </select></td> 
                        <td className='w-250'>
                            <select id="ddlConductProblems_2" name="ddlConductProblems_2" className='add-only'>
                                <option value=""></option>
                                <option value="0">None</option>
                                <option value="1">&#60; Month</option>
                                <option value="2">1 - 6 Months</option>
                                <option value="3">7 - 11 Months</option>
                                <option value="4">&#62; 1 Year</option>
                            </select></td> 
                    </tr>
                    <tr> 
                        <td className='w-250'><b>School Problems</b></td> 
                        <td className='w-250'>
                            <select id="ddlSchoolProblems_1" name="ddlSchoolProblems_1" className='add-only'>
                                <option value=""></option>
                                <option value="None">None</option>
                                <option value="Mild">Mild</option>
                                <option value="Moderate">Moderate</option>
                                <option value="Severe">Severe</option>
                            </select></td> 
                        <td className='w-250'>
                            <select id="ddlSchoolProblems_2" name="ddlSchoolProblems_2" className='add-only'>
                                <option value=""></option>
                                <option value="0">None</option>
                                <option value="1">&#60; Month</option>
                                <option value="2">1 - 6 Months</option>
                                <option value="3">7 - 11 Months</option>
                                <option value="4">&#62; 1 Year</option>
                            </select></td> 
                    </tr>
                    <tr> 
                        <td className='w-250'><b>Family Problems</b></td> 
                        <td className='w-250'>
                            <select id="ddlFamilyProblems_1" name="ddlFamilyProblems_1" className='add-only'>
                                <option value=""></option>
                                <option value="None">None</option>
                                <option value="Mild">Mild</option>
                                <option value="Moderate">Moderate</option>
                                <option value="Severe">Severe</option>
                            </select></td> 
                        <td className='w-250'>
                            <select id="ddlFamilyProblems_2" name="ddlFamilyProblems_2" className='add-only'>
                                <option value=""></option>
                                <option value="0">None</option>
                                <option value="1">&#60; Month</option>
                                <option value="2">1 - 6 Months</option>
                                <option value="3">7 - 11 Months</option>
                                <option value="4">&#62; 1 Year</option>
                            </select></td> 
                    </tr> 
                    <tr> 
                        <td className='w-250'><b>Indep. Living Problems</b></td> 
                        <td className='w-250'>
                            <select id="ddlLivingProblems_1" name="ddlLivingProblems_1" className='add-only'>
                                <option value=""></option>
                                <option value="None">None</option>
                                <option value="Mild">Mild</option>
                                <option value="Moderate">Moderate</option>
                                <option value="Severe">Severe</option>
                            </select></td> 
                        <td className='w-250'>
                            <select id="ddlLivingProblems_2" name="ddlLivingProblems_2" className='add-only'>
                                <option value=""></option>
                                <option value="0">None</option>
                                <option value="1">&#60; Month</option>
                                <option value="2">1 - 6 Months</option>
                                <option value="3">7 - 11 Months</option>
                                <option value="4">&#62; 1 Year</option>
                            </select></td> 
                    </tr> 
                    <tr> 
                        <td className='w-250'><b>Other</b></td> 
                        <td className='w-250'>
                            <select id="ddlOther_1" name="ddlOther_1" className='add-only'>
                                <option value=""></option>
                                <option value="None">None</option>
                                <option value="Mild">Mild</option>
                                <option value="Moderate">Moderate</option>
                                <option value="Severe">Severe</option>
                            </select></td> 
                        <td className='w-250'>
                            <select id="ddlOther_2" name="ddlOther_2" className='add-only'>
                                <option value=""></option>
                                <option value="0">None</option>
                                <option value="1">&#60; Month</option>
                                <option value="2">1 - 6 Months</option>
                                <option value="3">7 - 11 Months</option>
                                <option value="4">&#62; 1 Year</option>
                            </select>
                            </td> 
                    </tr>  

                </table> 

                <p>
                    <span className='eleHeader'>Briefly describe identified Symptoms: </span>
                    <textarea id="txtIdentifiedSymptoms" name="txtIdentifiedSymptoms" className='add-only'></textarea>
                </p>

                <p>
                    <span className='eleHeader'>Summary of Consumer's SNAPS (Strengths, Needs, Abilities, Preferences)</span>
                    <textarea id="txtSNAPS" name="txtSNAPS" className='add-only'></textarea>
                </p>

                <p>
                    <span className='eleHeader'>(Consumer's Goals/Hopes for the Future)</span>
                    <textarea id="txtConsumersGoals" name="txtConsumersGoals" className='add-only'></textarea>
                </p>

                <p>
                    <span className='eleHeader'>What things do you like about yourself?:</span>
                    <textarea id="txtYourself" name="txtYourself" className='add-only'></textarea>
                </p>

                <p>
                    <span className='eleHeader'>What things would you like to improve about your behaviors/symptoms & how?</span>
                    <textarea id="txtSymptoms" name="txtSymptoms" className='add-only'></textarea>
                </p>

                <p>
                    <span className='eleHeader'>What accomplishments are you most proud of in your personal life?:</span>
                    <textarea id="txtAccomplishments" name="txtAccomplishments" className='add-only'></textarea>
                </p>

                <p>
                    <span className='eleHeader'>Consumer's and family's expectations from participating in this program?:</span>
                    <textarea id="txtFamilysExpectations" name="txtFamilysExpectations" className='add-only'></textarea>
                </p>

                <h3>Summary of consumer's SNAPS (Strengths, Needs, Abilities and Preferences)</h3>
                <p>
                    <span className='eleHeader'>Strengths:</span>
                    <textarea id="txtStrengths" name="txtStrengths" className='add-only'></textarea>
                </p>

                <p>
                    <span className='eleHeader'>Needs:</span>
                    <textarea id="txtNeeds" name="txtNeeds" className='add-only'></textarea>
                </p>

                <p>
                    <span className='eleHeader'>Abilities:</span>
                    <textarea id="txtAbilities" name="txtAbilities" className='add-only'></textarea>
                </p>

                <p>
                    <span className='eleHeader'>Preferences:</span>
                    <textarea id="txtPreferences" name="txtPreferences" className='add-only'></textarea>
                </p>

                <p>
                    <span className='eleHeader'>Problems List:</span>
                    <textarea id="txtProblemsList" name="txtProblemsList" className='add-only'></textarea>
                </p>

                <h2>Clinical Summary</h2>
                <p>
                    <span className='eleHeader'>Diagnostic Rationale/Summary of Findings: </span>
                    <span className='small'>(Please summarize supporting information for diagnosis.)</span>
                    <textarea id="txtDiagnosticRationale" name="txtDiagnosticRationale" className='add-only'></textarea>
                </p>

                <p>
                    <span className='eleHeader'>Interpretive Summary:</span>
                    <textarea id="txtInterpretiveSummary" name="txtInterpretiveSummary" className='add-only'></textarea>
                </p>

                <span className='eleHeader'>Recommended Services:</span>
                <span className='small'>(Check all that apply.) </span>
                <table>
                    <tr>
                        <td className='w-500'><input type="checkbox" id="cbRS_1" name="cbRS_1" className='add-only' value="Community referrals made no further services needed" /> Community referrals made, no further services needed  </td>
                        <td className='w-250'><input type="checkbox" id="cbRS_2" name="cbRS_2" className='add-only' value="Medication assessment" /> Medication assessment  </td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type="checkbox" id="cbRS_3" name="cbRS_3" className='add-only' value="By primary care physician" /> By primary care physician</td>
                        <td className='w-250'><input type="checkbox" id="cbRS_4" name="cbRS_4" className='add-only' value="By ASOC or CSOG psychiatrist" /> By ASOC or CSOG psychiatrist</td>
                        <td className='w-250'><input type="checkbox" id="cbRS_5" name="cbRS_5" className='add-only' value="Individual therapy" /> Individual therapy</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type="checkbox" id="cbRS_6" name="cbRS_6" className='add-only' value="Brief therapy" /> Brief therapy</td>
                        <td className='w-250'><input type="checkbox" id="cbRS_7" name="cbRS_7" className='add-only' value="Long-term therapy" /> Long-term therapy</td>
                        <td className='w-250'><input type="checkbox" id="cbRS_8" name="cbRS_8" className='add-only' value="Family therapy" /> Family therapy</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type="checkbox" id="cbRS_9" name="cbRS_9" className='add-only' value="Collateral" /> Collateral</td>
                        <td className='w-250'><input type="checkbox" id="cbRS_10" name="cbRS_10" className='add-only' value="Group" /> Group</td>
                        <td className='w-250'><input type="checkbox" id="cbRS_11" name="cbRS_11" className='add-only' value="Testing" /> Testing</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type="checkbox" id="cbRS_12" name="cbRS_12" className='add-only' value="Day rehab/treatment" /> Day rehab/treatment</td>
                        <td className='w-250'><input type="checkbox" id="cbRS_13" name="cbRS_13" className='add-only' value="Other" /> Other</td>
                    </tr>
                </table>

                <p>
                    <span className='eleHeader'>If community referrals were made, please describe:</span>
                    <textarea id="txtCommunityReferrals" name="txtCommunityReferrals" className='add-only'></textarea>
                </p>

                <p>
                    <span className='eleHeader'>If client was placed on 1013, please give details:</span>
                    <span className='small'>(IE: Which hospital, how transported, etc.)</span>
                    <textarea id="txtDetails" name="txtDetails" className='add-only'></textarea>
                </p>

                <p>
                    <span className='eleHeader'>DSM V</span>
                    <textarea id="txtDSMV" name="txtDSMV" className='add-only'></textarea>
                </p>

                <p>
                    <span className='eleHeader'>Recommendations for Treatment/ Services:</span>
                    <span className='small'>(Please indicate what services you are recommended and how each service can benefit the client)</span>
                    <textarea id="txtRecommendations" name="txtRecommendations" className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td>
                            <span><strong>Projected date of Discharge/Transition:</strong></span>
                            <input type="date" id="txtDischargeDate" name="txtDischargeDate" className='add-only' />
                        </td>
                    </tr>
                </table>

                <p>
                    <span className='eleHeader'>Anticipated Stepdown: </span>
                    <span className='small'>(Please include specific step-down linkage in client's area, frequency, of attendance, and contact information of services that you will recommend once they have successfully completed services with A.C.E)</span>
                    <textarea id="txtAnticipatedStepdown" name="txtAnticipatedStepdown" className='add-only'></textarea>
                </p>

                <p>
                    <span className='eleHeader'>Discharge Plan</span>
                    <span className='small'>(Place all Objectives from the Treatment Plan in this section; the steps the individual has agreed to do to accomplish the goals):</span>
                    <textarea id="txtDischargePlan" name="txtDischargePlan" className='add-only'></textarea>
                </p>







            </div>
        </form>

    )
}    